/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Cashback error for service list
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { Button } from '../../../../components/common';
import { ImgStatusError, StatusStyled } from '../../../../components/common/Block/Img';
import { IPageCashbackControlTranslation } from '../../../../modules/internationalization/types/pages/cashback';
import { CashbackTextStyled } from '../styled/CashbackStyled';

export interface ICashbackControlServiceError {
    translation: IPageCashbackControlTranslation['statusError'];
    onClick: () => void;
}

const CashbackControlServiceError = (props: ICashbackControlServiceError) => {
    const { onClick, translation } = props;
    return (
        <StatusStyled>
            <ImgStatusError/>
            <CashbackTextStyled className="status__title">
                {translation.title}
            </CashbackTextStyled>
            <Button className="status__btn" onClick={onClick}>{translation.btn}</Button>
        </StatusStyled>
    );
};

export default CashbackControlServiceError;
